module.exports = __webpack_public_path__ + "static/img/vision.ceb8d66.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/vision.png
// module id = tMpH
// module chunks = 3